import { render, staticRenderFns } from "./Southkorea.vue?vue&type=template&id=4629e9d8&scoped=true&"
import script from "./Southkorea.vue?vue&type=script&lang=js&"
export * from "./Southkorea.vue?vue&type=script&lang=js&"
import style0 from "./Southkorea.vue?vue&type=style&index=0&id=4629e9d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4629e9d8",
  null
  
)

export default component.exports